import { render, staticRenderFns } from "./PageBasicSet.vue?vue&type=template&id=d1f626a0&scoped=true&"
import script from "./PageBasicSet.vue?vue&type=script&lang=js&"
export * from "./PageBasicSet.vue?vue&type=script&lang=js&"
import style0 from "./PageBasicSet.vue?vue&type=style&index=0&id=d1f626a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f626a0",
  null
  
)

component.options.__file = "PageBasicSet.vue"
export default component.exports